@if (items().length > 0) {
  <div class="flex flex-col">
    @for (item of items(); track item.key; let last = $last) {
      <div
        class="grid grid-cols-2 items-center gap-4 py-2.5"
        [class.border-b]="!last"
        [class.border-surface-switch-100]="!last"
      >
        <div class="flex items-center gap-1.5 min-w-0">
          <span class="text-sm text-surface-switch-600 truncate">{{
            item.label
          }}</span>
          @if (item.description) {
            <i
              class="pi pi-info-circle text-xs text-muted-color cursor-pointer shrink-0"
              [pTooltip]="item.description"
              tooltipPosition="top"
              appendTo="body"
              [attr.aria-label]="item.label + ' help'"
            ></i>
          }
        </div>
        <div>
          @if (item.type === "decimal") {
            <p-inputNumber
              [ngModel]="getDecimalValue(item.key)"
              [showButtons]="true"
              [mode]="'decimal'"
              [minFractionDigits]="0"
              [maxFractionDigits]="maxFractionDigits"
              [useGrouping]="false"
              [min]="item.min"
              [max]="item.max"
              (ngModelChange)="onDecimalChange(item.key, $event)"
              [placeholder]="item.defaultPlaceholder"
              class="w-full"
              inputStyleClass="w-full"
            />
          } @else if (item.type === "string") {
            @if (item.hasChoices) {
              <p-select
                [ngModel]="getStringValue(item.key)"
                (ngModelChange)="onStringChange(item.key, $event)"
                [options]="item.choices"
                optionLabel="label"
                optionValue="value"
                [placeholder]="item.defaultPlaceholder"
                [showClear]="true"
                class="w-full"
                appendTo="body"
              />
            } @else {
              <input
                pInputText
                type="text"
                class="w-full"
                [ngModel]="getStringValue(item.key)"
                (ngModelChange)="onStringChange(item.key, $event)"
                [placeholder]="item.defaultPlaceholder"
              />
            }
          } @else if (item.type === "boolean") {
            <p-checkbox
              [ngModel]="getBooleanValue(item.key)"
              (ngModelChange)="onBooleanChange(item.key, $event)"
              [binary]="true"
              [inputId]="getControlId(item.key)"
              [attr.aria-label]="item.label"
            />
          }
        </div>
      </div>
    }
  </div>
} @else {
  <p class="text-sm text-muted-color">No editable parameters</p>
}
